export const TRAVEL_CONDITIONS_PATH = '/travel-conditions';
export const OUR_POLICIES_PATH = '/our-policies';
